import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { CustomerLogos } from '../components/CustomerLogos';
import { FeaturesSection } from '../components/FeaturesSection';
import { VCLogos } from '../components/VCLogos';
import { CTABanner } from '../components/CTABanner';
export function HomePage() {
  return <>
      <HeroSection data-id="element-392" />
      <CustomerLogos data-id="element-393" />
      <FeaturesSection data-id="element-394" />
      <VCLogos data-id="element-395" />
      <CTABanner data-id="element-396" />
    </>;
}